export default __webpack_public_path__ + "static/media/demand.b58fb3c8.svg";